<template>
  <div v-if="isAdminRoute" class="admin-content-container">
    <!-- 관리자일 때만 admin-content-container를 렌더링 -->
    <AHeader />
    <div class="a-content-container">
      <router-view />
    </div>
  </div>

  <div v-else class="user-content-container">
    <!-- 비관리자일 때는 content-container만 렌더링 -->
    <!-- Tab: 특정 경로에서는 숨김 -->
    <Tab v-if="!hideTab" />
    <!-- Nav: Tab이 없으면 margin-top: 0 -->
    <!-- Nav: Tab이 없으면 margin-top: 0 -->
    <Nav v-if="!isMobile" :style="{ marginTop: hideTab ? '0px' : '44px' }" />
    <MNav />
    <div class="u-content-container">
      <router-view />
    </div>

    <Footer />
  </div>
  <!-- Top 버튼 -->
  <button class="top-button" @click="scrollToTop">TOP</button>
</template>

<script>
import { mapGetters } from "vuex";
import Tab from "./components/TabView.vue";
import Nav from "./components/NavView.vue";
import MNav from "./components/MNav.vue";
import Footer from "./components/FooterView.vue";
import AHeader from "./components/AHeader.vue";

export default {
  components: {
    Tab,
    Nav,
    MNav,
    Footer,
    AHeader,
  },
  computed: {
    ...mapGetters(["isAdmin"]),
    isAdminRoute() {
      return this.$route.path.startsWith("/admin");
    },

    hideTab() {
      return ["/", "/home", "/home/"].includes(this.$route.path);
    },
  },
  data() {
    return {
      isMobile: false,
    };
  },
  async mounted() {
    this.checkMobile();
    window.addEventListener("resize", this.checkMobile);
  },
  beforeUnmount() {
    window.removeEventListener("resize", this.checkMobile);
  },
  methods: {
    checkMobile() {
      this.isMobile = window.innerWidth <= 479;
    },
    scrollToTop() {
      const container = document.querySelector(".user-content-container");
      if (container) {
        container.scrollTop = 0;
        // 또는 부드럽게
        container.scrollTo({ top: 0, behavior: "smooth" });
      }
    },
  },
};
</script>

<style>
html,
body {
  margin: 0;
  height: 100%;
  width: 100%;
  max-width: 100%;
  overflow-x: hidden;
}

#app {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  align-items: center;
  text-align: center;
  /* 브라우저에 표현되는 텍스트가 렌더링될 때 부드럽게 표현됨 */
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.admin-content-container {
  margin-left: 282px;
}

.a-content-container {
  margin-top: 150px;
  margin-bottom: 200px;
}

.user-content-container {
  width: 100%;

  display: flex;
  flex-direction: column;

  overflow-y: auto;
  height: 100vh;
  scroll-behavior: smooth;
}

.u-content-container {
  display: flex;

  justify-content: center;
  box-sizing: border-box;
  margin-top: 150px;

  /* overflow-y: auto; */
  /* height: 100vh; */
}

.top-button {
  position: fixed;
  bottom: 30px;
  right: 50px;
  z-index: 1000;
  width: 60px; /* 너비 */
  height: 60px; /* 높이 */
  border-radius: 50%; /* 완전 원 */
  background-color: #555;
  color: white;
  border: none;
  font-size: 14px;
  cursor: pointer;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.2);
  transition: background-color 0.3s ease;
}

.top-button:hover {
  background-color: #03754e;
}

@media all and (max-width: 479px) {
  .user-content-container {
    width: 100%;
  }

  .u-content-container {
    padding-top: 80px;
    flex-direction: column;
    margin-top: 125px;
    padding: 0 16px;
  }

  .u-content-container > * {
    width: 100%;
  }

  .top-button {
    display: none;
  }
}
</style>
